/*
  TOSSIT header behavior
  ======================
  Two small additions on top of the theme's own machinery; everything else
  (drawer slide, focus traps, sticky header, cart bubble refresh) stays Dawn's.

  1. Hover intent for the desktop HOW TO dropdown. The theme opens dropdowns
     on click only; on a pointer device this opens on hover and closes on a
     cancellable delay, so a diagonal path down to a pill — or a beat of
     hesitation — never shuts the menu mid-reach. The CSS bridge in
     tossit-header.css covers the physical gap below the trigger.

  2. The drawer's HOW TO row, which expands inline. It is deliberately a
     <button>, not a <details>: the theme's MenuDrawer binds every summary
     inside the drawer to its slide-a-panel-in pattern (and expects a close
     button in the submenu), which is not this interaction.
*/

(function () {
  var CLOSE_DELAY = 260;
  var finePointer = window.matchMedia('(pointer: fine)');

  function initDropdownHover() {
    document.querySelectorAll('.tossit-header .tnav header-menu').forEach(function (menu) {
      var details = menu.querySelector('details');
      var summary = menu.querySelector('summary');
      if (!details || !summary) return;

      var timer = null;

      menu.addEventListener('mouseenter', function () {
        if (!finePointer.matches) return;
        window.clearTimeout(timer);
        if (!details.hasAttribute('open')) {
          details.setAttribute('open', '');
          summary.setAttribute('aria-expanded', 'true');
        }
      });

      menu.addEventListener('mouseleave', function () {
        if (!finePointer.matches) return;
        window.clearTimeout(timer);
        timer = window.setTimeout(function () {
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
        }, CLOSE_DELAY);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('.tossit-header .tnav details[open]').forEach(function (details) {
        details.removeAttribute('open');
        var summary = details.querySelector('summary');
        if (summary) {
          summary.setAttribute('aria-expanded', 'false');
          summary.focus();
        }
      });
    });
  }

  function initDrawerHowTo() {
    // Dawn's MenuDrawer treats EVERY <button> inside the drawer as a
    // submenu close button (bindEvents wires them all to onCloseButtonClick),
    // so a plain listener on the toggle would expand How To and close the
    // whole drawer in the same tap. Handling the click at the document in
    // the capture phase runs before any listener on the button itself, and
    // stopPropagation keeps it from ever reaching Dawn's.
    document.addEventListener(
      'click',
      function (event) {
        var button = event.target.closest && event.target.closest('[data-tossit-howto]');
        if (!button) return;
        event.stopPropagation();
        button.focus({ preventScroll: true });
        var item = button.closest('li');
        var opening = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(opening));
        if (item) item.toggleAttribute('data-open', opening);
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initDropdownHover();
      initDrawerHowTo();
    });
  } else {
    initDropdownHover();
    initDrawerHowTo();
  }
})();

/*
  3. Condense on scroll.

     The header is configured for Dawn's "reduce logo size" sticky type, and
     header.liquid ships the matching rule (.scrolled-past-header shrinks the
     logo wrapper to 75%). But the class never landed: Dawn's StickyHeader
     never initialises against this custom markup, so the logo stayed full
     size on every page no matter how far you scrolled.

     Rather than restore Dawn's controller, this toggles the same class it
     would have. The CSS contract is unchanged, so if StickyHeader ever does
     initialise, both agree and nothing double-applies.

     The threshold is the header's own height, so the bar is full size while
     any of it is still in its original position, and condenses once the page
     has genuinely scrolled past it. A small hysteresis gap stops it flipping
     back and forth when a scroll stops exactly on the boundary.
*/
(function () {
  var header = document.querySelector('.header-wrapper');
  if (!header) return;

  var CLASS = 'scrolled-past-header';
  var ticking = false;

  function threshold() {
    return Math.max(header.offsetHeight || 0, 40);
  }

  function apply() {
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    var on = header.classList.contains(CLASS);
    var t = threshold();

    if (!on && y > t) {
      header.classList.add(CLASS);
    } else if (on && y < t - 12) {
      header.classList.remove(CLASS);
    }
    ticking = false;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(apply);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  apply();
})();

/*
  Every surface on this store that adds to the cart, as one selector shared
  by the toast, the cart-icon reaction and the button theatre.

  Tag-qualified throughout: best-sellers grids set to "go to product page"
  emit <a class="quick-add__submit"> navigation links, and answering those
  would celebrate a click that adds nothing.
*/
var ATC_SELECTOR =
  'button[name="add"], button.product-form__submit, button.quick-add__submit, #tl-atc, #tlf-btn';

/*
  4. Instant add-to-cart feedback.

     Dawn's notification popup only appears after the cart request and a
     section re-render come back, which on a slow connection is most of a
     second of nothing happening. This shows a small branded "Adding…"
     toast the moment any add-to-cart form submits, then hands off: as
     soon as the real notification opens (or a second and a half passes,
     for cart-drawer setups), the toast leaves. Optimistic in feel, never
     wrong in fact - it claims "adding", not "added".
*/
(function () {
  var toast;
  var hideTimer;

  function ensureToast() {
    if (toast) return toast;
    toast = document.createElement('div');
    toast.className = 'th-add-toast';
    toast.setAttribute('role', 'status');
    toast.innerHTML = '<span class="th-add-toast__dot"></span><span class="th-add-toast__text"></span>';
    document.body.appendChild(toast);
    return toast;
  }

  function show(msg) {
    var t = ensureToast();
    t.querySelector('.th-add-toast__text').textContent = msg;
    t.classList.add('is-on');
  }

  function hide() {
    if (toast) toast.classList.remove('is-on');
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
    show('Adding to cart…');

    var timeout = window.setTimeout(hide, 1500);

    var note = document.getElementById('cart-notification');
    if (note && 'MutationObserver' in window) {
      var mo = new MutationObserver(function () {
        if (note.classList.contains('active')) {
          window.clearTimeout(timeout);
          hide();
          mo.disconnect();
        }
      });
      mo.observe(note, { attributes: true, attributeFilter: ['class'] });
      window.setTimeout(function () { mo.disconnect(); }, 4000);
    }
  }, true);

  /*
     Submit is not a reliable signal on this store.

     A cart-drawer app binds the add-to-cart button, calls preventDefault and
     does its own fetch, so on those pages the click happens and the submit
     event never does - verified live: clickObserved true, submitEventFired
     false. Anything hooked only to submit is silent exactly where the app is
     loudest. The same is true of the landing price button and the sticky
     sale bar, which are <button type="button"> and never submit anything.

     Click always fires. Hook that. On pages where the form does submit, both
     paths run and the second is a no-op, because show() only sets a class.
  */
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest(ATC_SELECTOR);
      if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
      show('Adding to cart…');
      window.clearTimeout(hideTimer);
      hideTimer = window.setTimeout(hide, 1800);
    },
    true
  );
})();

/*
  5. Cart icon reaction — two beats, because there are two different things
     worth telling someone.

     Beat one, the nudge, fires the instant a cart button is pressed. It is a
     receipt for the click, not for the cart, so it is allowed to be wrong
     about the outcome: an add that later fails still deserved acknowledgement
     at the moment of pressing. This is the part that covers a slow connection,
     where Dawn otherwise gives most of a second of nothing.

     Beat two, the pop, fires only on PUB_SUB_EVENTS.cartUpdate, which every
     add path publishes - product-form, quick-add-bulk, and the cart itself.
     That matters because the quick-add buttons in collection grids add by
     fetch and never submit a form, so §4's toast never sees them; this does.

     The timing is dictated by cart-notification.js:69, which replaces the
     icon's innerHTML wholesale. cartUpdate is published BEFORE that render,
     so popping on the event alone would animate a count bubble that is about
     to be thrown away. Instead the event arms an observer and the pop waits
     for the new markup to land. Classes go on the <a>, which survives the
     render; the animations target its descendants, which do not - and that
     also keeps us clear of the hover transform the <a> already owns.
*/
(function () {
  var NUDGE_MS = 620;
  var POP_MS = 700;
  var RENDER_WAIT_MS = 1200;

  function icon() {
    return document.getElementById('cart-icon-bubble');
  }

  // Re-adding a class the element already carries will not restart a CSS
  // animation; the reflow between removal and re-add is what does.
  function replay(el, cls, ms) {
    if (!el) return;
    el.classList.remove(cls);
    void el.offsetWidth;
    el.classList.add(cls);
    window.setTimeout(function () {
      el.classList.remove(cls);
    }, ms);
  }

  function nudge() {
    replay(icon(), 'th-cart-nudge', NUDGE_MS);
  }

  // Waits for the section re-render before popping, so the bubble being
  // animated is the one carrying the new count.
  function popWhenRendered() {
    var a = icon();
    if (!a) return;

    var fired = false;
    var mo = null;
    var fallback;

    function fire() {
      if (fired) return;
      fired = true;
      if (mo) mo.disconnect();
      window.clearTimeout(fallback);
      // A confirmed add supersedes the acknowledgement, so drop the nudge
      // rather than leaving both classes to be settled by stylesheet order.
      a.classList.remove('th-cart-nudge');
      replay(a, 'th-cart-pop', POP_MS);
    }

    if ('MutationObserver' in window) {
      mo = new MutationObserver(fire);
      mo.observe(a, { childList: true, subtree: true });
    }

    // Nothing guarantees a re-render — an add of an item already in the cart
    // can leave the markup identical. Pop anyway rather than stay silent.
    fallback = window.setTimeout(fire, RENDER_WAIT_MS);
  }

  document.addEventListener(
    'submit',
    function (e) {
      if (e.target.matches && e.target.matches('form[data-type="add-to-cart-form"]')) nudge();
    },
    true
  );

  // Covers the fetch-based paths that never submit: quick add in the grids,
  // and the bulk quantity controls.
  document.addEventListener(
    'click',
    function (e) {
      // Tag-qualified on purpose: best-sellers grids set to "go to product
      // page" emit <a class="quick-add__submit"> navigation links. Matching
      // those would bounce the cart icon on a click that adds nothing.
      var btn = e.target.closest && e.target.closest(ATC_SELECTOR);
      if (!btn || btn.getAttribute('aria-disabled') === 'true' || btn.disabled) return;
      nudge();
    },
    true
  );

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, popWhenRendered);
  }

  // Two live buy paths never touch Dawn: the landing hero price button
  // (#tl-atc) and the sticky sale bar (#tlf-btn). Both POST /cart/add.js
  // directly and announce themselves only with a 'cart:refresh' event that
  // nothing listens to - so without this they add silently, which is the
  // exact complaint this work exists to fix. Both live in template
  // custom_liquid, which syncs slowly and belongs to other work; hooking
  // them from here changes no template.
  document.addEventListener(
    'click',
    function (e) {
      var direct = e.target.closest && e.target.closest('#tl-atc, #tlf-btn');
      if (direct && !direct.disabled) nudge();
    },
    true
  );

  /*
     Those same two buttons leave the cart icon stale. Dawn only re-renders
     the cart-icon-bubble section as part of its own add; a bare
     fetch('/cart/add.js') updates the server cart and nothing else, so the
     count sits at its old number until the next full page load. That is not
     a slow page - the icon is never told anything changed.

     So tell it. Re-request the cart-icon-bubble section and swap in the
     markup Shopify renders, which is the same mechanism Dawn uses, then pop.
     Looking up #cart-icon-bubble inside the parsed response rather than
     assuming a wrapper means this keeps working whether the section renders
     the anchor itself or only its contents. If that request fails, fall back
     to /cart.js and write the count by hand rather than leave it wrong.
  */
  function refreshCartIcon() {
    var a = icon();
    if (!a || typeof fetch !== 'function') return popWhenRendered();

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + '?section_id=cart-icon-bubble')
      .then(function (r) {
        if (!r.ok) throw new Error('section');
        return r.text();
      })
      .then(function (html) {
        // sections/cart-icon-bubble.liquid renders the INNER contents of the
        // <a id="cart-icon-bubble"> - the glyph, the screen-reader label and
        // the count bubble - and nothing carries that id. Looking for
        // #cart-icon-bubble in the response therefore always missed, and this
        // silently fell through to the /cart.js branch below, which rebuilds
        // the count by hand and loses the visually-hidden count screen
        // readers announce. Take the section wrapper's contents, which is
        // exactly what belongs inside the anchor.
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('#cart-icon-bubble') || doc.querySelector('.shopify-section');
        if (!fresh) throw new Error('shape');
        a.innerHTML = fresh.innerHTML;
        replay(a, 'th-cart-pop', POP_MS);
      })
      .catch(function () {
        return fetch(root + 'cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var bubble = a.querySelector('.cart-count-bubble');
            if (!cart.item_count) {
              if (bubble) bubble.remove();
            } else {
              if (!bubble) {
                bubble = document.createElement('div');
                bubble.className = 'cart-count-bubble';
                a.appendChild(bubble);
              }
              bubble.innerHTML =
                '<span aria-hidden="true">' + (cart.item_count < 100 ? cart.item_count : '') + '</span>';
            }
            replay(a, 'th-cart-pop', POP_MS);
          })
          .catch(function () {});
      });
  }

  document.addEventListener('cart:refresh', refreshCartIcon);

  /*
     The cart-drawer app adds by its own fetch and never publishes anything
     this theme listens to, so the count in the header stayed on its old
     number until a reload. Nothing here can know when that app's request
     lands, so ask the cart shortly after any add-to-cart press. Debounced,
     because on a Dawn page cartUpdate arrives too and one refresh is
     enough; whichever fires first wins and the other is dropped.
  */
  var refreshTimer;
  function scheduleRefresh(delay) {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refreshCartIcon, delay);
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest(ATC_SELECTOR);
      if (btn && !btn.disabled && btn.getAttribute('aria-disabled') !== 'true') scheduleRefresh(1100);
    },
    true
  );
})();

/*
  6. The add-to-cart button plays a little theatre.

     After Aaron Iker's add-to-cart interaction (the CodePen the cart
     keyframes are lifted from), rebranded: where his cart pauses for a
     checkmark, ours pauses dead centre of the button and a TOSSIT dart
     drops in from above - fins up, cup down - the cart dips under the
     landing, then rolls off with the dart aboard and the label returns.

     Buttons are enhanced lazily on first submit rather than in Liquid,
     because the same button renders from buy-buttons, card-product,
     card-variant and best-sellers, and a runtime wrapper means one code
     path instead of four templates. Two things happen at enhance time:

     - loose text nodes get wrapped in a span. buy-buttons already wraps
       its label; the card and best-seller buttons ship bare text, and a
       bare text node cannot be animated out.
     - the stage (cart + dart) is appended, hidden until the run.

     Only real adds animate: the trigger is submit on the add-to-cart
     form, so the "Choose options" modal-openers - which also carry
     name="add" but add nothing - never fire it. A cartError cuts the
     run short: no celebration for a failed add. Reduced-motion users
     skip the theatre entirely and keep Dawn's plain loading state.
*/
(function () {
  var RUN_MS = 3000;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  // The dart is the house silhouette from tossit-landing-why - dome, neck,
  // ribbed grip, suction cup - not a redrawing of it. Filled, because at
  // basket scale a stroked outline closes up into mud; the solid shape stays
  // legible at 7px wide and matches the weight of the cart's 2.5 stroke.
  var STAGE_HTML =
    '<span class="th-atc-stage" aria-hidden="true">' +
    '<span class="th-atc-roll">' +
    '<svg class="th-atc-cart" viewBox="0 0 36 26" fill="none">' +
    '<polyline points="1 2.5 6 2.5 10 18.5 25.5 18.5 28.5 7.5 7.5 7.5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>' +
    '<svg class="th-atc-dart" viewBox="0 0 24 62">' +
    '<path fill="currentColor" d="M12 1 C18 1 22 5 22 10 C22 15 17 17 15 22 L14 30 L14 40 L16 42 L18 44 L18 50 L15 52 L14 54 C17 55 20 57 22 59 L22 61 L2 61 L2 59 C4 57 7 55 10 54 L9 52 L6 50 L6 44 L8 42 L10 40 L10 30 L9 22 C7 17 2 15 2 10 C2 5 6 1 12 1 Z"/>' +
    '</svg>' +
    '</span>' +
    '</span>';

  function enhance(btn) {
    if (btn.querySelector('.th-atc-stage')) return;

    // The landing price button is not a word on a button - it is a small
    // layout of price rows, a save line and its own sparkles. Tagging each of
    // those spans as a label would animate them independently and pull the
    // composition apart. Wrap the whole thing once instead, so it leaves and
    // returns as the single block it reads as.
    if (btn.matches('#tl-atc, #tlf-btn')) {
      var block = document.createElement('span');
      block.className = 'th-atc-label';
      while (btn.firstChild) block.appendChild(btn.firstChild);
      btn.appendChild(block);
      btn.insertAdjacentHTML('beforeend', STAGE_HTML);
      return;
    }

    // Bare text can't be transformed; give every loose word a span.
    Array.prototype.slice.call(btn.childNodes).forEach(function (node) {
      if (node.nodeType === 3 && node.textContent.trim()) {
        var wrap = document.createElement('span');
        node.parentNode.insertBefore(wrap, node);
        wrap.appendChild(node);
      }
    });

    // Every label span gets the class - wrapped text and native spans alike -
    // so the CSS has one honest hook. Our own furniture (stage, sheen,
    // sparks) is skipped by prefix.
    Array.prototype.forEach.call(btn.children, function (el) {
      if (el.tagName === 'SPAN' && el.className.indexOf('th-atc-') === -1) {
        el.classList.add('th-atc-label');
      }
    });

    btn.insertAdjacentHTML('beforeend', STAGE_HTML);
    dress(btn);
  }

  /*
     Idle dress: the primary product ATC gets the Club button's treatment -
     the gloss sheen sweep and the two off-beat four-point sparkles - now in
     white on the red. Only .product-form__submit: one hero button per page.
     The same thing on every card in a twelve-product grid would be a
     Christmas tree, so the cards stay quiet at rest and speak on click.

     The animations run only under .th-atc-idle, which an IntersectionObserver
     grants in-viewport - the house rule that nothing loops off-screen
     (and without JS nothing loops at all, which is the safe default).
  */
  var SPARK_SVG =
    '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 1.5c.7 5.4 4.4 9.1 9.8 9.8-5.4.7-9.1 4.4-9.8 9.8-.7-5.4-4.4-9.1-9.8-9.8C7.6 10.6 11.3 6.9 12 1.5Z"/></svg>';

  var idleWatch =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (en) {
              en.target.classList.toggle('th-atc-idle', en.isIntersecting);
            });
          },
          { rootMargin: '60px' }
        )
      : null;

  var selfDressingPage = !!document.getElementById('tl-atc');

  function dress(btn) {
    if (!btn.matches || !btn.matches('.product-form__submit')) return;
    if (btn.querySelector('.th-atc-sheen')) return;

    // Six landing templates dress this same button themselves in
    // custom_liquid: their own sheen (::before), their own .tl-spk sparkles,
    // their own red. Dressing it again stacks two sheens and four sparkles on
    // one button.
    //
    // Their marker cannot be the test. This file is deferred, so it executes
    // at readyState "interactive" - BEFORE the DOMContentLoaded handler their
    // inline script registered during parse. We always win that race, so
    // data-tl-done is never set yet and their sparkles do not exist yet.
    // Checking them looks correct and silently double-dresses every landing
    // page, which is exactly what shipped.
    //
    // #tl-atc is server-rendered HTML, present at parse time, and every
    // template that self-dresses has one. Ask the page, not the button.
    if (selfDressingPage) return;
    if (btn.dataset.tlDone || btn.querySelector('.tl-spk')) return;

    btn.insertAdjacentHTML(
      'beforeend',
      '<span class="th-atc-sheen" aria-hidden="true"></span>' +
        '<span class="th-atc-spark th-atc-spark--a" aria-hidden="true">' + SPARK_SVG + '</span>' +
        '<span class="th-atc-spark th-atc-spark--b" aria-hidden="true">' + SPARK_SVG + '</span>'
    );
    if (idleWatch) idleWatch.observe(btn);
  }

  function dressAll() {
    document.querySelectorAll('.product-form__submit').forEach(dress);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', dressAll);
  } else {
    dressAll();
  }

  function run(btn) {
    if (!btn || reduceMotion.matches) return;
    // LUMO buttons have their own add feedback (the lamp colour-cycle in
    // lumo.js) - a dart landing in a basket is the wrong brand there.
    if (btn.closest && btn.closest('.lumo')) return;
    if (btn.classList.contains('th-atc-loading')) return;

    // A stage needs room. Below this the cart would fill the whole button
    // and the clipped roll reads as glitch, not theatre - those buttons keep
    // Dawn's spinner, and the header icon + toast still carry the feedback.
    if (btn.offsetWidth < 110 || btn.offsetHeight < 30) return;

    enhance(btn);
    btn.classList.add('th-atc-loading');
    btn.thAtcTimer = window.setTimeout(function () {
      btn.classList.remove('th-atc-loading');
    }, RUN_MS);
  }

  function cancel() {
    document.querySelectorAll('.th-atc-loading').forEach(function (btn) {
      window.clearTimeout(btn.thAtcTimer);
      btn.classList.remove('th-atc-loading');
    });
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
      run(form.querySelector('button[type="submit"][name="add"]'));
    },
    true
  );

  // Click, not submit. A cart-drawer app preventDefaults the add-to-cart
  // button and adds by its own fetch, so on those pages submit never fires
  // and the theatre never played - which is precisely what the customer
  // reported. Click fires either way; where the form does submit too, run()
  // returns early on the second call because the button is already loading.
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest(ATC_SELECTOR);
      if (btn && !btn.disabled && btn.getAttribute('aria-disabled') !== 'true') run(btn);
    },
    true
  );

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartError, cancel);
  }
})();

/*
  7. Content protection — the JS half of the CSS in theme.liquid.

     Blocks the right-click save route and image dragging. Deliberately
     narrow about what it refuses:

     - Form fields keep their context menu. Taking it away removes cut,
       paste, spellcheck and Look Up from a customer mid-checkout, which
       costs a sale to protect nothing.
     - The arcade canvas already suppresses its own context menu as a game
       control, so it is left alone rather than fought over.
     - Long-press on a phone is handled by -webkit-touch-callout in CSS;
       there is no contextmenu event to cancel on iOS.

     What this cannot do: stop a screenshot, devtools, view-source, or
     someone opening the image's CDN URL directly. Anyone determined still
     gets the file. This raises the effort, it does not seal anything.
*/
(function () {
  var TYPEABLE = 'input, textarea, select, [contenteditable], [contenteditable] *';

  document.addEventListener(
    'contextmenu',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest(TYPEABLE)) return;
      if (t.closest('canvas')) return;
      e.preventDefault();
    },
    false
  );

  // Dragging an image out to the desktop is the other one-gesture download.
  document.addEventListener(
    'dragstart',
    function (e) {
      var t = e.target;
      if (t && t.tagName && /^(IMG|PICTURE|VIDEO|SVG)$/i.test(t.tagName)) e.preventDefault();
    },
    false
  );
})();

/*
  8. Repair for the welded video attribute.

     sections/tossit-video-spotlight.liquid renders a spotlight video whose
     src and poster are withheld behind data- attributes until it scrolls
     near. A Liquid comment placed between two of those attributes stripped
     the whitespace on both sides and fused them into one attribute named
     "data-vs-videodata-vs-src". The element ends up with no src and no
     poster, and the section's own script - which finds the video by
     [data-vs-video] - returns before doing anything. The result is a black
     rectangle on the homepage and every landing page.

     That is fixed in the section file and has been on main for some time,
     but the file is not reaching the live theme, while assets sync in
     seconds. This lives here because it is the delivery route that works.

     Deliberately narrow: it only acts when the welded key is present, so on
     any page already serving the corrected section it does nothing at all.
     It can be deleted once the section file lands - leaving it costs one
     querySelectorAll over a handful of elements.
*/
(function () {
  function repair() {
    var videos = document.querySelectorAll('video.vs__video');
    Array.prototype.forEach.call(videos, function (video) {
      // dataset key for the fused attribute data-vs-videodata-vs-src
      var fused = video.dataset.vsVideodataVsSrc;
      if (!fused) return;

      video.setAttribute('data-vs-video', '');
      video.dataset.vsSrc = fused;
      delete video.dataset.vsVideodataVsSrc;
      video.removeAttribute('data-vs-videodata-vs-src');

      // The section's script did not just fail to hydrate - it returned on
      // its first line, so NOTHING downstream ran. Tapping the video and the
      // play and sound buttons were all dead, which is a worse bug than the
      // black frame because it looks like the whole section is inert. Those
      // controls have to be rebuilt here, matching what the section does:
      // the same is-paused class, the same data-sound-on attribute, the same
      // aria state and label text, so the CSS and screen readers still agree.
      var section = video.closest('.video-spotlight') || video.closest('[id*="spotlight"]');
      var playButton = section && section.querySelector('[data-vs-play]');
      var soundButton = section && section.querySelector('[data-vs-sound]');
      var soundLabel = section && section.querySelector('[data-vs-sound-label]');

      function syncPaused() {
        if (section) section.classList.toggle('is-paused', video.paused);
      }

      function load() {
        // Poster and src arrive together, under the observer below. Setting
        // the poster at DOMContentLoaded instead pulled a full-width JPEG for
        // a section eight screens down, on every page view that never reached
        // it. This matches what the section's own hydrate() does.
        if (!video.getAttribute('poster') && video.dataset.vsPoster) {
          video.poster = video.dataset.vsPoster;
        }
        // Read the dataset at load time rather than the value captured when
        // this ran. Section 9 rewrites it to a web-sized rendition after this
        // block has already executed, and a stale closure would re-request the
        // 37MB master and undo that saving.
        if (!video.getAttribute('src')) video.src = video.dataset.vsSrc || fused;
      }

      function play() {
        load();
        var attempt = video.play();
        if (attempt && attempt.catch) attempt.catch(syncPaused);
      }

      function toggle() {
        if (video.paused) play();
        else video.pause();
      }

      video.addEventListener('play', syncPaused);
      video.addEventListener('pause', syncPaused);
      syncPaused();

      video.addEventListener('click', toggle);
      if (playButton) playButton.addEventListener('click', toggle);

      if (soundButton) {
        soundButton.addEventListener('click', function () {
          var turningOn = video.muted;
          video.muted = !turningOn;
          if (section) section.setAttribute('data-sound-on', String(turningOn));
          soundButton.setAttribute('aria-pressed', String(turningOn));
          soundButton.setAttribute('aria-label', turningOn ? 'Turn sound off' : 'Turn sound on');
          if (soundLabel) soundLabel.textContent = turningOn ? 'Sound off' : 'Sound on';
          // Unmuting is deliberate - make sure there is something to hear.
          if (turningOn && video.paused) play();
        });
      }

      // Autoplay muted once it scrolls near, as the section intended: a
      // full-size video eleven screens down should not load on page view.
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              load();
              if (!reduce) play();
              io.disconnect();
            });
          },
          { threshold: 0.25 }
        );
        io.observe(video);
      } else {
        load();
        if (!reduce) play();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', repair);
  } else {
    repair();
  }
})();

/*
  9. Point the spotlight video at a web-sized rendition.

     The configured Files URL is a 37MB master - 1920x1080 at 15.5 Mbps for a
     20-second loop - because Shopify does not transcode Files uploads. Three
     renditions now ship in assets/ (1080p 5.6MB, 720p 2.8MB, 480p 1.8MB -
     measured, the older figures here were half the real sizes) and the
     section chooses between them.

     This exists because that section file has not reached the live theme,
     while assets sync in seconds. Until it lands, the markup still names the
     master, so the choice is made here instead and a phone pulls 0.9MB rather
     than 37MB.

     Runs before the video is scrolled into view, so the section's own hydrate
     reads the rewritten value and never requests the master. It is skipped
     entirely once the section ships renditions of its own, and skipped for
     any other video, since these files are renditions of this clip alone -
     playing the wrong footage would be worse than a heavy file.
*/
(function () {
  var MASTER = 'b73c3179e3cf4e66baf50f9030b9111f';

  // assetBase() returns "<prefix>|<?v=...>"; rejoin around the filename.
  function url(base, file) {
    var cut = base.lastIndexOf('|');
    return base.slice(0, cut) + file + base.slice(cut + 1);
  }

  // The theme directory (t/20) changes between publishes, so the base is read
  // off an asset the page has already loaded rather than hardcoded.
  function assetBase() {
    var el = document.querySelector('link[href*="/assets/"], script[src*="/assets/"]');
    if (!el) return null;
    var url = el.getAttribute('href') || el.getAttribute('src') || '';
    var at = url.indexOf('/assets/');
    if (at < 0) return null;
    // Keep the sampled asset's ?v= so these URLs are versioned. Without it the
    // CDN can hand out a stale encode of the same filename for days, which it
    // was doing: an 8-day-old first-pass file.
    var q = url.indexOf('?', at);
    return url.slice(0, at + 8) + '|' + (q < 0 ? '' : url.slice(q));
  }

  function rendition(base, video) {
    var conn = navigator.connection;
    if (conn && (conn.saveData || /(^|-)(2g|slow-2g|3g)$/.test(conn.effectiveType || ''))) {
      return url(base, 'tossit-spotlight-480.mp4');
    }
    // Phones take the 720p: at 854x480 the loop read soft on a retina screen,
    // which is a resolution problem rather than a bitrate one. The 480p is now
    // only for the constrained connections handled above.
    //
    // Measure the ELEMENT, not the window. .vs__inner caps the frame at 900px,
    // so the video renders ~804px wide on every viewport past ~940px and a
    // wider window buys no extra pixels - which is why branching on
    // window.innerWidth shipped the 1080p master to every desktop. 720p is
    // 1280 wide, covering an 804px frame to ~1.6x DPR.
    //
    // Still viewport-shaped, not viewport x DPR - see the section for why that
    // inverted the order between a dense tablet and a larger laptop.
    var w = 0;
    if (video && video.getBoundingClientRect) w = Math.round(video.getBoundingClientRect().width);
    if (!w) w = Math.min(window.innerWidth || 1280, 900);
    if (w <= 1099) return url(base, 'tossit-spotlight-720.mp4');
    return url(base, 'tossit-spotlight-1080.mp4');
  }

  function downgrade() {
    var videos = document.querySelectorAll('video.vs__video');
    if (!videos.length) return;

    var base = assetBase();
    if (!base) return;

    Array.prototype.forEach.call(videos, function (video) {
      var d = video.dataset;
      if (d.vsSrc1080) return; // section already picks a rendition itself

      var small = rendition(base, video);
      // The withheld source, for the normal deferred path.
      if (d.vsSrc && d.vsSrc.indexOf(MASTER) > -1) d.vsSrc = small;
      // The fused attribute, if this page is still serving that markup.
      if (d.vsVideodataVsSrc && d.vsVideodataVsSrc.indexOf(MASTER) > -1) {
        d.vsVideodataVsSrc = small;
      }
      // And a src already on the element, which only happens on the older
      // eager markup - swapping it there saves the download outright.
      var live = video.getAttribute('src') || '';
      if (live.indexOf(MASTER) > -1) video.src = small;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', downgrade);
  } else {
    downgrade();
  }
})();

/*
  10. Lazy-load looping clips in the shop-page photo clusters.

      tossit-collection-band.liquid can swap a photo slot for a small muted
      loop instead of a static image - built for exactly one problem:
      Shopify does not transcode animated GIFs. Measured on the file this
      replaced: requesting a SMALLER width (600) produced an 11.68MB
      response, bigger than the untouched original (9.15MB). No width
      parameter gets a multi-MB GIF under control, only a re-encode does,
      and the encoded clip is ~0.3MB against the GIF's ~9MB.

      Same contract as tossit-landing-imf.liquid: no src until the element is
      actually visible, so three tilted thumbnails on the shop page do not
      fetch video the instant the section exists on the page. Pauses again
      on scroll-out rather than tearing down the source, so re-entering the
      viewport resumes instead of re-fetching.
*/
(function () {
  var clips = document.querySelectorAll('.ts__shot-clip[data-toss-clip]');
  if (!clips.length || !('IntersectionObserver' in window)) return;

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          if (!v.src) {
            v.src = v.dataset.src;
            v.load();
          }
          var attempt = v.play();
          if (attempt && attempt.catch) attempt.catch(function () {});
        } else if (!v.paused) {
          v.pause();
        }
      });
    },
    { threshold: 0.2 }
  );

  clips.forEach(function (v) {
    io.observe(v);
  });
})();

/*
  11. Neutralise the landing-page buy buttons inside a quick-add modal.

      The "Choose options" modal loads a product page and transplants its
      buy column into a dialog on top of whatever page you were already on.
      Dawn rewrites the ids on the form it owns, so its own Add to cart is
      correct. The landing-template buttons are not so lucky:

        var f = document.querySelector('form[action*="/cart/add"] [name="id"]');
        var id = (f && f.value) || b.getAttribute("data-variant-id");

      That is a document-wide lookup, written when the button could only
      ever appear on its own product page. In a modal it reaches straight
      past the dialog and reads the FIRST cart form in the host document -
      a different product's card. Opening the Starter Pack Classic modal
      and pressing the yellow price button added a Family Board to the
      cart. Same for the sticky sale bar (#tlf-btn), which is page furniture
      that has no business inside a dialog at all.

      Fixing the lookup would mean editing the inline script in ten product
      templates; suppressing the buttons in the one place they misbehave is
      both smaller and safer, and the modal already carries a working Add to
      cart three rows below.

      #tl-atc is also the only thing on these templates that renders a
      price, so it is kept visible and demoted to a price plaque rather than
      hidden - see .tq-inert in quick-add.css. Neutralised three ways
      because each covers a different route in: the class removes the button
      affordance, `disabled` blocks pointer and keyboard activation, and the
      capture-phase listener stops any click that still gets through before
      it can reach the template's own handler bound to the button itself.
*/
(function () {
  var INERT = '#tl-atc, #tlf-btn';

  function neutralise(root) {
    root.querySelectorAll(INERT).forEach(function (btn) {
      if (btn.dataset.tqInert) return;
      btn.dataset.tqInert = '1';
      btn.classList.add('tq-inert');
      btn.disabled = true;
      btn.setAttribute('tabindex', '-1');
      // The caption reads "… — tap to add to cart", which is no longer true.
      var caption = btn.querySelector('.c');
      if (caption) caption.remove();
    });
  }

  // Swallow the click before it reaches the handler the template bound
  // directly to the button. A capture listener on the document runs ahead
  // of any target-phase listener, so stopPropagation here means the event
  // never arrives.
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest(INERT);
      if (!btn || !btn.closest('quick-add-modal')) return;
      e.preventDefault();
      e.stopPropagation();
    },
    true
  );

  // Modal content is fetched and injected on first open, so there is
  // nothing to neutralise at page load. Watch each modal for its content
  // landing instead.
  function watch(modal) {
    if (modal.dataset.tqWatched) return;
    modal.dataset.tqWatched = '1';
    neutralise(modal);
    new MutationObserver(function () {
      neutralise(modal);
    }).observe(modal, { childList: true, subtree: true });
  }

  function init() {
    document.querySelectorAll('quick-add-modal').forEach(watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/*
  12. Best-sellers colourway swatches.

      The cards used to carry two separate things: decorative swatch dots
      that linked away to the product page, and a "Choose options" button
      that loaded the entire product page into a dialog in order to ask
      which colour. Now the dots are the control - pick one and the card
      shows that colourway, at that colourway's price, ready to add.

      Everything this needs is already in the markup, rendered by Liquid:
      the variant id, the image, and one price block per variant with all
      but the current one hidden. So no fetch, no product JSON, no money
      formatting in JS - just moving a `hidden` attribute and swapping two
      image attributes. That is what keeps it instant.
*/
(function () {
  function selectSwatch(sw) {
    var card = sw.closest('.bs__card');
    if (!card) return;

    var id = sw.getAttribute('data-variant-id');
    if (!id) return;

    card.querySelectorAll('[data-bs-swatch]').forEach(function (other) {
      var on = other === sw;
      other.classList.toggle('is-selected', on);
      other.setAttribute('aria-pressed', String(on));
    });

    // What the form will actually post.
    var input = card.querySelector('input.product-variant-id, input[name="id"]');
    if (input) input.value = id;

    /*
       srcset has to be set before src, and the old srcset has to go with
       it. Leaving a stale srcset in place means the browser keeps choosing
       a candidate from it and the new src is never used - the price and the
       swatch ring would update while the photo stayed on the old colour.
    */
    var img = card.querySelector('.bs__media img');
    var src = sw.getAttribute('data-img');
    if (img && src) {
      var srcset = sw.getAttribute('data-srcset');
      if (srcset) img.setAttribute('srcset', srcset);
      else img.removeAttribute('srcset');
      img.setAttribute('src', src);
    }

    var prices = card.querySelectorAll('[data-bs-price-for]');
    prices.forEach(function (p) {
      p.hidden = p.getAttribute('data-bs-price-for') !== id;
    });

    // A sold-out colourway must not leave an enabled Add to cart behind it.
    var btn = card.querySelector('button[name="add"]');
    if (btn) {
      var available = sw.getAttribute('data-available') !== 'false';
      btn.disabled = !available;
      var label = btn.querySelector('span:not(.sold-out-message)');
      var soldOut = btn.querySelector('.sold-out-message');
      if (label && soldOut) {
        label.classList.toggle('hidden', !available);
        soldOut.classList.toggle('hidden', available);
      }
    }
  }

  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('[data-bs-swatch]');
    if (!sw) return;
    e.preventDefault();
    selectSwatch(sw);
  });
})();

/*
  13. Pause the Fan Favorites flame while it is off screen.

      Two SVG paths at 15px is not much, but SVG transform animations run on
      the main thread and keep ticking style recalcs whether or not anything
      is visible - and best-sellers sits in the middle of pages people leave
      open. Same treatment the landing pages give .tl-shine.
*/
(function () {
  var flames = document.querySelectorAll('.bs__kicker-flame');
  if (!flames.length) return;

  if (!('IntersectionObserver' in window)) return; // Animation just runs; harmless.

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      entry.target.classList.toggle('is-off', !entry.isIntersecting);
    });
  });

  flames.forEach(function (f) {
    io.observe(f);
  });
})();

/*
   14. Colour dots inside the gold buy card - phones only.

   The landing buy button sits ~600px above the variant picker on a phone,
   so tapping it silently bought the default colourway; most shoppers never
   learned the other three existed. This paints one dot per colour option
   INSIDE the card and proxies taps to the real radios, so Dawn's own
   variant machinery (price, gallery, form value) does every bit of the
   actual work. Nothing is moved in the DOM and the real picker stays where
   it was; this is a remote control, not a replacement.

   Fails silent: no card, no radios, or anything throwing leaves the page
   exactly as it was.
*/
(function () {
  'use strict';
  if (window.__tlCardSwatches) return;
  window.__tlCardSwatches = true;

  var HUES = { red:'#e8443a', cherry:'#e8443a', cyan:'#2ec4c4', teal:'#2ec4c4', mint:'#7fe0c3',
    blue:'#29a3e0', navy:'#1d2b57', yellow:'#edbd00', sunflower:'#edbd00', gold:'#edbd00',
    pink:'#f68bbe', blossom:'#f6a8c8', purple:'#8b5cf6', lavender:'#b9a7f2', green:'#5cc63f',
    orange:'#f26722', peach:'#ffb38a', cream:'#f6f2e7', milky:'#f6f2e7', white:'#ffffff', black:'#121212' };
  function hueFor(word) {
    word = String(word || '').toLowerCase();
    for (var k in HUES) if (word.indexOf(k) !== -1) return HUES[k];
    return '#cfc9bb';
  }
  function dotStyle(value) {
    var parts = String(value).split('+').map(function (x) { return hueFor(x.trim()); });
    if (parts.length >= 2) return 'background:linear-gradient(135deg,' + parts[0] + ' 50%,' + parts[1] + ' 50%)';
    return 'background:' + parts[0];
  }

  function build() {
    try {
      var atc = document.getElementById('tl-atc');
      if (!atc || document.querySelector('.tlcs')) return;
      var scope = atc.closest('.product__info-container') || document;
      var radios = [].slice.call(scope.querySelectorAll('variant-radios input[type="radio"], variant-selects input[type="radio"]'));
      if (radios.length < 2 || radios.length > 8) return;

      var row = document.createElement('div');
      row.className = 'tlcs';
      row.setAttribute('role', 'radiogroup');
      row.setAttribute('aria-label', 'Pick your colors');
      var label = document.createElement('span');
      label.className = 'tlcs__label';
      label.textContent = 'Colors:';
      row.appendChild(label);

      radios.forEach(function (r) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'tlcs__dot';
        d.setAttribute('style', dotStyle(r.value));
        d.setAttribute('aria-label', r.value);
        d.title = r.value;
        if (r.checked) d.classList.add('is-on');
        d.addEventListener('click', function (e) {
          e.preventDefault();
          try {
            r.checked = true;
            r.dispatchEvent(new Event('change', { bubbles: true }));
          } catch (err) {}
        });
        r.addEventListener('change', function () { sync(); });
        d.__radio = r;
        row.appendChild(d);
      });

      function sync() {
        row.querySelectorAll('.tlcs__dot').forEach(function (d) {
          d.classList.toggle('is-on', !!(d.__radio && d.__radio.checked));
        });
      }
      scope.addEventListener('change', function (e) {
        if (e.target && e.target.type === 'radio') sync();
      });

      atc.insertAdjacentElement('afterend', row);
    } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build);
  else build();
})();

